// extracted by mini-css-extract-plugin
export default {"bold":"styles_bold__l2Xbe","memberImage":"styles_memberImage__eg4aD","weekday":"styles_weekday__0wRsg"};